module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-networksettings"
  }, [_c('form', {
    staticClass: "u-form"
  }, [_c('div', {
    staticClass: "kiwi-networksettings-section kiwi-networksettings-connection"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_server_details')))]), _vm._v(" "), (_vm.network.state_error) ? _c('div', {
    staticClass: "kiwi-networksettings-error"
  }, [_vm._v("We couldn't connect to that server :( "), _c('span', [_vm._v(_vm._s(_vm.readableStateError(_vm.network.state_error)))])]) : _vm._e(), _vm._v(" "), _c('input-text', {
    staticClass: "kiwi-networksettings-connection-address",
    attrs: {
      "label": _vm.$t('server')
    },
    model: {
      value: (_vm.network.connection.server),
      callback: function($$v) {
        _vm.network.connection.server = $$v
      },
      expression: "network.connection.server"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "kiwi-networksettings-connection-port",
    attrs: {
      "label": _vm.$t('settings_port'),
      "type": "number"
    },
    model: {
      value: (_vm.network.connection.port),
      callback: function($$v) {
        _vm.network.connection.port = $$v
      },
      expression: "network.connection.port"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-lg kiwi-customserver-tls",
    class: [_vm.network.connection.tls ? 'kiwi-customserver-tls--enabled' : ''],
    on: {
      "click": _vm.toggleTls
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-stack-1x kiwi-customserver-tls-lock"
  }), _vm._v(" "), (!_vm.network.connection.tls) ? _c('i', {
    staticClass: "fa fa-times fa-stack-1x kiwi-customserver-tls-minus"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-networksettings-connection-password"
  }, [(_vm.server_type === 'network') ? [_c('input-text', {
    attrs: {
      "label": _vm.$t('password'),
      "type": "password"
    },
    model: {
      value: (_vm.network.connection.password),
      callback: function($$v) {
        _vm.network.connection.password = $$v
      },
      expression: "network.connection.password"
    }
  })] : [_c('input-text', {
    attrs: {
      "label": _vm.$t('username')
    },
    model: {
      value: (_vm.znc_username),
      callback: function($$v) {
        _vm.znc_username = $$v
      },
      expression: "znc_username"
    }
  }), _vm._v(" "), _c('input-text', {
    attrs: {
      "label": _vm.$t('network')
    },
    model: {
      value: (_vm.znc_network),
      callback: function($$v) {
        _vm.znc_network = $$v
      },
      expression: "znc_network"
    }
  }), _vm._v(" "), _c('input-text', {
    attrs: {
      "label": _vm.$t('password'),
      "type": "password"
    },
    model: {
      value: (_vm.znc_password),
      callback: function($$v) {
        _vm.znc_password = $$v
      },
      expression: "znc_password"
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "kiwi-networksettings-server-types"
  }, [(_vm.server_type === 'znc') ? _c('div', {
    staticClass: "kiwi-networksettings-server-types-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('settings_znc_other')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "u-link",
    class: {
      'kiwi-networksettings-server-type-active': _vm.server_type === 'network'
    },
    on: {
      "click": function($event) {
        _vm.server_type = 'network'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('network')))]), _vm._v(" "), _c('a', {
    staticClass: "u-link",
    class: {
      'kiwi-networksettings-server-type-active': _vm.server_type === 'znc'
    },
    on: {
      "click": function($event) {
        _vm.server_type = 'znc'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('znc')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "kiwi-networksettings-section  kiwi-networksettings-user"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_nickname')))]), _vm._v(" "), _c('input-text', {
    attrs: {
      "label": _vm.$t('settings_nickname')
    },
    model: {
      value: (_vm.network.nick),
      callback: function($$v) {
        _vm.network.nick = $$v
      },
      expression: "network.nick"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "kiwi-networksettings-section kiwi-networksettings-advanced"
  }, [_c('h3', {
    on: {
      "click": function($event) {
        _vm.show_advanced = !_vm.show_advanced
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('settings_advanced')) + " "), _c('i', {
    staticClass: "fa",
    class: ['fa-caret-' + (_vm.show_advanced ? 'up' : 'down')],
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.show_advanced) ? [_c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_encoding')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.network.connection.encoding),
      expression: "network.connection.encoding"
    }],
    domProps: {
      "value": (_vm.network.connection.encoding)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.network.connection.encoding = $event.target.value
      }
    }
  })]), _c('br'), _vm._v(" "), _c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('settings_show_raw')) + ": ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingShowRaw),
      expression: "settingShowRaw"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settingShowRaw) ? _vm._i(_vm.settingShowRaw, null) > -1 : (_vm.settingShowRaw)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settingShowRaw,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settingShowRaw = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settingShowRaw = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settingShowRaw = $$c
        }
      }
    }
  })]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "u-form-block"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('settings_autorun')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.network.auto_commands),
      expression: "network.auto_commands"
    }],
    attrs: {
      "cols": "40",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.network.auto_commands)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.network.auto_commands = $event.target.value
      }
    }
  })])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "kiwi-networksettings-section kiwi-networksettings-danger"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('settings_danger')))]), _vm._v(" "), _c('label', [_c('a', {
    staticClass: "u-button u-button-warning",
    on: {
      "click": _vm.removeNetwork
    }
  }, [_vm._v(_vm._s(_vm.$t('settings_remove')))])]), _c('br')])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d423314!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NetworkSettings.vue
// module id = 502
// module chunks = 2